import { render, staticRenderFns } from "./LoginPersonalizePreviewTerm.vue?vue&type=template&id=47b907a8&scoped=true"
import script from "./LoginPersonalizePreviewTerm.vue?vue&type=script&lang=js"
export * from "./LoginPersonalizePreviewTerm.vue?vue&type=script&lang=js"
import style0 from "./LoginPersonalizePreviewTerm.vue?vue&type=style&index=0&id=47b907a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b907a8",
  null
  
)

export default component.exports